import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import { saveNote } from '../../features/notes/notesSlice';
import { authLoginSelector } from '../../features/auth/authLoginSlice';
import { UpdateFileDetailsExpress } from '../../features/orders/orderSlice';
import { useNavigate } from 'react-router-dom';
import { getFileIDfromFileNumber, getFileNumberfromFileID } from '../../common/utils';

const AcceptPickupPopup = ({ setAcceptPopupDailog, selectedReadyForpickupOrders, setSelectedRows, reloadTabs, isRedirectTopolicyPickup = false, filenumber }) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userLogin } = useSelector(authLoginSelector)
  const navigate = useNavigate();
  return (
    <div>
      <dialog
        id="delete_dialog2"
        className="modal"
        open
      >
        <span
          className="modal-content"
        >
          <div className="absolute top-0 right-0 mt-3 mr-4">
            <button
              id="ConfirmPickup"
              className="text-black font-medium hover:text-black-light focus:outline-none focus:text-black-light transition ease-in-out duration-150"
              onClick={() => setAcceptPopupDailog(false)}
            >
              <span className="text-xl">&times;</span>
            </button>
          </div>

          <div className="mt-8 text-justify">
            {t("AcceptPickupMsg1")}
            <br/>
            <br/>
            {t("AcceptPickupMsg2")}
            <br/>
            <br/>
            {t("AcceptPickupMsg3")}
            
          </div>
          <div className="mb-4 mt-12">
            <button
              id="ConfirmPickup"
              className="btn__primary w-[115px] py-[10px] justify-center"
              onClick={() => {
                if (isRedirectTopolicyPickup) {
                  debugger;
                  dispatch(UpdateFileDetailsExpress(getFileIDfromFileNumber(filenumber), "", true, "Policy Pickup Accepted", userLogin?.userId));
                  setAcceptPopupDailog(false);
                  navigate(`/orderstatus/?tab=2`);
                }
                else {
                  let files = selectedReadyForpickupOrders.map(x => x?.original?.fileID).join(", ");
                  if (!files)
                    files = selectedReadyForpickupOrders.map(x => x?.fileID).join(", ");
                  dispatch(UpdateFileDetailsExpress(0, files, true, "Policy Pickup Accepted", userLogin?.userId));
                  setAcceptPopupDailog(false);
                  setSelectedRows({});
                  reloadTabs();
                }

              }}
            >
              {t("Confirm")}
            </button>
          </div>
        </span>
      </dialog>
    </div>
  )
}

export default AcceptPickupPopup
